export { default } from "./customer-location-details";